import Lottie from "lottie-react";
import animationLaptop from '../../utils/animations/laptop-animation.json';
import animationLaptopOne from '../../utils/animations/laptop-one-animation.json';
import buildAppMobile from '../../utils/animations/build-app-mobile.json';
import animationIoT from '../../utils/animations/iot-animation.json';
import animationCloud from '../../utils/animations/cloud-animation.json';
import animationDigitalTransformation from '../../utils/animations/transformation-digital-animation.json';

export function LaptopAnimation() {
    return (
        <Lottie 
            className="animation m-auto"
            animationData={animationLaptop} 
            loop 
            autoplay 
            style={{width: 300, height: 300}} />
    )
}

export function LaptopOneAnimation() {
    return(
        <Lottie 
            className="animation m-auto"
            animationData={animationLaptopOne}
            loop
            autoplay
            style={{width: 300, height:300}} />
    )
}

export function BuildAppMobile() {
    return(
        <Lottie 
            className="animation m-auto"
            animationData={buildAppMobile}
            loop
            autoplay
            speed={0.1} />
    )
}

export function IoTAnimacion() {
    return(
        <Lottie 
            className="animation m-auto"
            animationData={animationIoT}
            loop
            autoplay
            speed={0.1} />
    )
}

export function CloudAnimation() {
    return(
        <Lottie 
            className="animation m-auto"
            animationData={animationCloud}
            loop
            autoplay
            speed={0.1} />
    )
}

export function TransformationDigitalAnimation() {
    return(
        <Lottie 
            className="animation m-auto"
            animationData={animationDigitalTransformation}
            loop
            autoplay
            speed={0.1} />
    );
}